<template>
  <div class="main-wrapper authendication-pages">
    <div class="content">
      <div class="container wrapper no-padding">
        <div class="row no-margin vph-100">
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 no-padding">
            <div class="banner-bg register">
              <div class="row no-margin h-100">
                <div class="col-sm-10 col-md-10 col-lg-10 mx-auto">
                  <div class="h-100 d-flex justify-content-center align-items-center">
                    <div class="text-bg register text-center">
                      <button type="button" class="btn btn-limegreen text-capitalize">
                        <i class="fa-solid fa-thumbs-up me-3"></i>register Now
                      </button>
                      <p>
                        Register now for our innovative sports software solutions,
                        designed to tackle challenges in everyday sports activities and
                        events.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-6 no-padding">
            <div class="dull-pg">
              <div class="row no-margin vph-100 d-flex align-items-center justify-content-center">
                <div class="col-sm-10 col-md-10 col-lg-10 mx-auto">
                  <header class="text-center">
                    <router-link to="/index">
                      <img src="@/assets/img/logo-black.svg" class="img-fluid" alt="Logo" />
                    </router-link>
                  </header>
                  <div class="shadow-card">
                    <h2>Get Started With Dreamsports</h2>
                    <p>
                      Ignite your sports journey with DreamSports and get started now.
                    </p>

                    <ul class="nav nav-tabs" id="myTab" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button class="nav-link active d-flex align-items-center" id="user-tab" data-bs-toggle="tab"
                          data-bs-target="#user" type="button" role="tab" aria-controls="user" aria-selected="true">
                          <span class="d-flex justify-content-center align-items-center"></span>I am a User
                        </button>
                      </li>
                      <li class="nav-item" role="presentation">
                        <button class="nav-link d-flex align-items-center" id="coach-tab" data-bs-toggle="tab"
                          data-bs-target="#coach" type="button" role="tab" aria-controls="coach" aria-selected="false">
                          <span class="d-flex justify-content-center align-items-center"></span>I am a Coach
                        </button>
                      </li>
                    </ul>
                    <div class="tab-content" id="myTabContent">
                      <div class="tab-pane fade show active" id="user" role="tabpanel" aria-labelledby="user-tab">
                        <!-- Register Form -->
                        <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
                          <div class="form-group">
                            <div class="group-img">
                              <i class="feather-user"></i>
                              <input type="text" class="form-control" placeholder="Username" />
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="group-img">
                              <i class="feather-mail"></i>
                              <Field name="email" type="text" class="form-control" placeholder="Email"
                                :class="{ 'is-invalid': errors.email }" />
                              <div class="invalid-feedback">{{ errors.email }}</div>
                              <div class="emailshow text-danger" id="email"></div>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="pass-group group-img">
                              <i class="toggle-password feather-eye-off"></i>
                              <Field name="password" :type="showPassword ? 'text' : 'password'"
                                class="form-control pass-input mt-2" placeholder="Password"
                                :class="{ 'is-invalid': errors.password }" />
                              <span @click="toggleShow" class="toggle-password">
                                <i :class="{
                                  'fas fa-eye': showPassword,
                                  'fas fa-eye-slash': !showPassword,
                                }"></i>
                              </span>
                              <div class="invalid-feedback">{{ errors.password }}</div>
                              <div class="emailshow text-danger" id="password"></div>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="pass-group group-img">
                              <i class="toggle-password-confirm feather-eye-off"></i>
                              <Field name="confirmpassword" :type="showPassword1 ? 'text' : 'password'"
                                class="form-control pass-input mt-2" placeholder="Confirm Password"
                                :class="{ 'is-invalid': errors.confirmpassword }" />
                              <span @click="toggleShow1" class="toggle-password">
                                <i :class="{
                                  'fas fa-eye': showPassword1,
                                  'fas fa-eye-slash': !showPassword1,
                                }"></i>
                              </span>
                              <div class="invalid-feedback">
                                {{ errors.confirmpassword }}
                              </div>
                              <div class="emailshow text-danger" id="confirmpassword"></div>
                            </div>
                          </div>
                          <div class="form-check d-flex justify-content-start align-items-center policy">
                            <div class="d-inline-block">
                              <input class="form-check-input" type="checkbox" value="" id="policy" />
                            </div>
                            <label class="form-check-label" for="policy">By continuing you indicate that you read and
                              agreed to the
                              <router-link to="/pages/terms-condition">Terms of Use</router-link></label>
                          </div>
                          <button
                            class="btn btn-secondary register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                            type="submit">
                            Create Account<i class="feather-arrow-right-circle ms-2"></i>
                          </button>
                          <div class="form-group">
                            <div class="login-options text-center">
                              <span class="text">Or continue with</span>
                            </div>
                          </div>
                          <div class="form-group mb-0">
                            <ul class="social-login d-flex justify-content-center align-items-center">
                              <li class="text-center">
                                <button type="button"
                                  class="btn btn-social d-flex align-items-center justify-content-center">
                                  <img src="@/assets/img/icons/google.svg" class="img-fluid" alt="Google" />
                                  <span>Google</span>
                                </button>
                              </li>
                              <li class="text-center">
                                <button type="button"
                                  class="btn btn-social d-flex align-items-center justify-content-center">
                                  <img src="@/assets/img/icons/facebook.svg" class="img-fluid" alt="Facebook" />
                                  <span>Facebook</span>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </Form>
                        <!-- /Register Form -->
                      </div>
                      <div class="tab-pane fade" id="coach" role="tabpanel" aria-labelledby="coach-tab">
                        <!-- Register Form -->
                        <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
                          <div class="form-group">
                            <div class="group-img">
                              <i class="feather-user"></i>
                              <input type="text" class="form-control" placeholder="Username" />
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="group-img">
                              <i class="feather-mail"></i>
                              <Field name="email" type="text" class="form-control" placeholder="Email"
                                :class="{ 'is-invalid': errors.email }" />
                              <div class="invalid-feedback">{{ errors.email }}</div>
                              <div class="emailshow text-danger" id="email"></div>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="pass-group group-img">
                              <i class="toggle-password feather-eye-off"></i>
                              <Field name="password" :type="showPassword ? 'text' : 'password'"
                                class="form-control pass-input mt-2" placeholder="Password"
                                :class="{ 'is-invalid': errors.password }" />
                              <span @click="toggleShow" class="toggle-password">
                                <i :class="{
                                  'fas fa-eye': showPassword,
                                  'fas fa-eye-slash': !showPassword,
                                }"></i>
                              </span>
                              <div class="invalid-feedback">{{ errors.password }}</div>
                              <div class="emailshow text-danger" id="password"></div>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="pass-group group-img">
                              <i class="toggle-password-confirm feather-eye-off"></i>
                              <Field name="confirmpassword" :type="showPassword1 ? 'text' : 'password'"
                                class="form-control pass-input mt-2" placeholder="Confirm Password"
                                :class="{ 'is-invalid': errors.confirmpassword }" />
                              <span @click="toggleShow1" class="toggle-password">
                                <i :class="{
                                  'fas fa-eye': showPassword1,
                                  'fas fa-eye-slash': !showPassword1,
                                }"></i>
                              </span>
                              <div class="invalid-feedback">
                                {{ errors.confirmpassword }}
                              </div>
                              <div class="emailshow text-danger" id="confirmpassword"></div>
                            </div>
                          </div>
                          <div class="form-check d-flex justify-content-start align-items-center policy">
                            <div class="d-inline-block">
                              <input class="form-check-input" type="checkbox" value="" id="terms" />
                            </div>
                            <label class="form-check-label" for="terms">By continuing you indicate that you read and
                              agreed to the
                              <router-link to="/pages/terms-condition">Terms of Use</router-link></label>
                          </div>
                          <button
                            class="btn btn-secondary register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                            type="submit">
                            Create Account<i class="feather-arrow-right-circle ms-2"></i>
                          </button>
                          <div class="form-group">
                            <div class="login-options text-center">
                              <span class="text">Or continue with</span>
                            </div>
                          </div>
                          <div class="form-group mb-0">
                            <ul class="social-login d-flex justify-content-center align-items-center">
                              <li class="text-center">
                                <button type="button"
                                  class="btn btn-social d-flex align-items-center justify-content-center">
                                  <img src="@/assets/img/icons/google.svg" class="img-fluid" alt="Google" />
                                  <span>Google</span>
                                </button>
                              </li>
                              <li class="text-center">
                                <button type="button"
                                  class="btn btn-social d-flex align-items-center justify-content-center">
                                  <img src="@/assets/img/icons/facebook.svg" class="img-fluid" alt="Facebook" />
                                  <span>Facebook</span>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </Form>
                        <!-- /Register Form -->
                      </div>
                    </div>
                  </div>
                  <div class="bottom-text text-center">
                    <p>Have an account? <router-link to="/">Sign In!</router-link></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import { router } from "@/router";
export default {
  data() {
    return {
      showPassword: false,
      showPassword1: false,
      password: null,
    };
  },
  components: {
    Form,
    Field,
  },
  computed: {
    buttonLabel() {
      return this.showPassword ? "Hide" : "Show";
    },
    buttonLabel() {
      return this.showPassword1 ? "Hide" : "Show";
    },
  },
  methods: {
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShow1() {
      this.showPassword1 = !this.showPassword1;
    },
  },
  setup() {
    const showPassword = ref(false);
    const emailError = ref("");
    const passwordError = ref("");

    const schema = Yup.object().shape({
      email: Yup.string().required("Email is required").email("Email is invalid"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      confirmpassword: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Confirm password is required"),
    });

    const onSubmit = (values) => {
      if (values.password === values.confirmpassword) {
        let Rawdata = localStorage.getItem("storedData");
        let Pdata = [];
        Pdata = JSON.parse(Rawdata);
        const Eresult = Pdata.find(({ email }) => email == values.email);
        if (Eresult) {
          document.getElementById("email").innerHTML = "This email are already exist";
        } else {
          Pdata.push(values);
          const jsonData = JSON.stringify(Pdata);
          router.push("/");
          localStorage.setItem("storedData", jsonData);
        }
      } else {
        document.getElementById("confirmpassword").innerHTML = "Password not matching";
      }
    };

    return {
      schema,
      onSubmit,
    };
  },
};
</script>